{
  "SEARCH": {
    "TABS": {
      "ALL": "Alle",
      "CONTACTS": "Kontakter",
      "CONVERSATIONS": "Samtaler",
      "MESSAGES": "Beskeder"
    },
    "SECTION": {
      "CONTACTS": "Kontakter",
      "CONVERSATIONS": "Samtaler",
      "MESSAGES": "Beskeder"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Søger",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ to focus",
    "INPUT_PLACEHOLDER": "Search messages, contacts or conversations",
    "RECENT_MESSAGES": "Mine senest sendte beskeder",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results.",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "WROTE": "wrote:",
    "FROM": "fra",
    "EMAIL": "e-mail",
    "EMAIL_SUBJECT": "emne"
  }
}
